/* eslint-disable import/no-named-as-default */
/* eslint-disable no-shadow */
import React from "react";
import PropTypes from "prop-types";
import DesktopDateFilter from "./DateFilters/DesktopDateFilter";
import MobileDateFilter from "./DateFilters/MobileDateFilter";

export const DateFilter = (props) => {
  const { isOutsideRange } = props;

  if (window.innerWidth < 767) {
    return <MobileDateFilter isOutsideRange={isOutsideRange} />;
  }
  return <DesktopDateFilter isOutsideRange={isOutsideRange} />;
};

DateFilter.propTypes = {
  isOutsideRange: PropTypes.any.isRequired,
};

export default DateFilter;
